import React from "react";
import { CheckOutlined, GlobalOutlined, DownOutlined } from "@ant-design/icons";
import { Menu, Dropdown } from "antd";
import lang from "assets/data/language.data.json";
import { connect } from "react-redux";
import { onLocaleChange } from "redux/actions/Theme";
import _ from "lodash";

function getLanguageDetail(locale, lkLanguages) {
  if (_.isArray(lkLanguages) && !_.isEmpty(lkLanguages)) {
    const data = lkLanguages.filter((elm) => elm.locale === locale);
    return data[0];
  }
  const data = lang.filter((elm) => elm.locale === locale);
  return data[0];
}

const SelectedLanguage = ({ locale, lkLanguages }) => {
  const language = getLanguageDetail(locale, lkLanguages);
  const { name, icon } = language;
  return (
    <div className="d-flex align-items-center">
      {(icon !== undefined && icon !== null) ?? (
        <img
          style={{ maxWidth: "20px" }}
          src={`${process.env.PUBLIC_URL}/img/flags/${icon}.png`}
          alt={name}
        />
      )}
      <span className="font-weight-semibold ml-2">
        {name} <DownOutlined className="font-size-xs" />
      </span>
    </div>
  );
};

export const NavLanguage = ({
  locale,
  configDisplay,
  onLocaleChange,
  lkLanguages,
}) => {
  const languageAPIOption = (
    <Menu>
      {lkLanguages.map((elm, i) => {
        return (
          <Menu.Item
            key={i}
            className={
              locale === elm.locale ? "ant-dropdown-menu-item-active" : ""
            }
            onClick={() => onLocaleChange(elm)}
          >
            <span className="d-flex justify-content-between align-items-center">
              <div>
                {(elm.icon !== undefined && elm.icon !== null) ?? (
                  <img
                    style={{ maxWidth: "20px" }}
                    src={`${process.env.PUBLIC_URL}/img/flags/${elm.icon}.png`}
                    alt={elm.name}
                  />
                )}
                <span className="font-weight-normal ml-2">{elm.name}</span>
              </div>
              {locale === elm.locale ? (
                <CheckOutlined className="text-success" />
              ) : null}
            </span>
          </Menu.Item>
        );
      })}
    </Menu>
  );
  return (
    <Dropdown
      placement="bottomRight"
      overlay={
        _.isArray(lkLanguages) && !_.isEmpty(lkLanguages)
          ? languageAPIOption
          : languageAPIOption
      }
      trigger={["click"]}
    >
      {configDisplay ? (
        <a href="#/" className="text-gray" onClick={(e) => e.preventDefault()}>
          <SelectedLanguage locale={locale} lkLanguages={lkLanguages} />
        </a>
      ) : (
        <Menu mode="horizontal">
          <Menu.Item key="language">
            <a href="#/" onClick={(e) => e.preventDefault()}>
              <GlobalOutlined className="nav-icon mr-0" />
            </a>
          </Menu.Item>
        </Menu>
      )}
    </Dropdown>
  );
};

const mapStateToProps = ({ theme, lookup }) => {
  const { locale } = theme;
  const { lkLanguages } = lookup;

  return { locale, lkLanguages };
};

export default connect(mapStateToProps, { onLocaleChange })(NavLanguage);
